var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7498 11.2528C22.7498 10.3175 22.6723 9.63501 22.5047 8.92725H11.6069V13.1486H18.0037C17.8748 14.1976 17.1784 15.7775 15.6307 16.8391L15.609 16.9804L19.0547 19.5964L19.2934 19.6197C21.4858 17.6354 22.7498 14.7158 22.7498 11.2528Z",
    fill: "#00AA11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6063 22.3749C14.7402 22.3749 17.3711 21.3637 19.2928 19.6196L15.6301 16.8389C14.65 17.5088 13.3345 17.9764 11.6063 17.9764C8.53693 17.9764 5.9318 15.9922 5.00314 13.2495L4.86702 13.2608L1.28416 15.9782L1.2373 16.1059C3.14601 19.8217 7.06664 22.3749 11.6063 22.3749Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00391 13.2496C4.75888 12.5418 4.61707 11.7834 4.61707 10.9999C4.61707 10.2162 4.75888 9.4579 4.99102 8.75014L4.98453 8.5994L1.35676 5.83838L1.23806 5.89371C0.451393 7.43567 0 9.16723 0 10.9999C0 12.8325 0.451393 14.564 1.23806 16.1059L5.00391 13.2496Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3691 4.3983C13.5486 4.3983 15.0188 5.32094 15.8572 6.09196L19.133 2.9575C17.1211 1.12487 14.503 0 11.3691 0C6.82936 0 2.90871 2.55304 1 6.26884L4.75297 9.12527C5.69452 6.38263 8.29966 4.3983 11.3691 4.3983Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.55d3d78857daf70a659fffee258e0fb7.svg";
export { ForwardRef as ReactComponent };